import { SxProps, Theme } from '@mui/material'

export const containerSx = {
  position: 'relative',
  width: '64px',
  height: '64px',
  borderRadius: '8px',
  cursor: 'pointer',
  objectFit: 'cover',
}

export const getActionWrapperSx = (isRemoved: boolean): SxProps<Theme> => ({
  position: 'absolute',
  right: '-5px',
  top: '-5px',
  backgroundColor: '#000000af',
  borderRadius: '50%',
  width: '20px',
  height: '20px',
  transform: !isRemoved ? undefined : 'rotate(45deg)',
})

export const getImageStyles = (isRemoved: boolean): SxProps<Theme> => ({
  maxWidth: '64px',
  minWidth: '64px',
  minHeight: '64px',
  maxHeight: '64px',
  borderRadius: '8px',
  cursor: 'pointer',
  objectFit: 'cover',
  border: isRemoved ? '2px solid #E01717' : '2px solid rgb(2, 57, 102)',
  outline: isRemoved ? 'solid #E01717' : 'solid rgb(2, 57, 102)',
})
